import type { NavGate, NavSection } from 'app/types/navigation'
import { hasNavProduct } from 'lib/sidebarItems'
import type { NavItemType } from 'types/Sidebar'

export function isNavItemVisible(item: NavItemType, gate: NavGate): boolean {
  if (item.if === false) return false
  if (!hasNavProduct(gate.products, item.product, gate.inWorkspace)) return false
  if (item.superUserOnly && !gate.isSuperUser) return false
  if (item.feature && !gate.isFeatureEnabled(item.feature)) return false
  return !item.permission || gate.checkPermission(item.permission)
}

export function filterNavItems(items: NavItemType[], gate: NavGate): NavItemType[] {
  return items.flatMap((item) => {
    if (!isNavItemVisible(item, gate)) return []
    if (!item.children?.length) return [item]
    // staff-v2 is released: child roles are no longer enforced in the nav.
    const children = item.children.filter((child) => isNavItemVisible(child, gate))
    if (!children.some((child) => !child.divider)) return []
    // A row-only item with no page of its own opens on the first child this user can reach.
    const href = item.href ?? (item.rowOnly ? children.find((child) => !child.divider)?.href : undefined)
    return [{ ...item, href, children }]
  })
}

export function filterNavSections(sections: NavSection[], gate: NavGate): NavSection[] {
  return sections.flatMap((section) => {
    const items = filterNavItems(section.items, gate)
    return items.length > 0 ? [{ ...section, items }] : []
  })
}
